// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2wcgL","image":"App_image__3oEeR"};